import urlMapping from '../../data/urlMapping.json';

// Validates use cases when product page does not exist for a given locale or
// when product name is different in the product center
const getValidProductCenterUrl = (productCenterLink) => {
  let validPathKey;

  switch (true) {
    case productCenterLink.includes('etx-support-local'):
      validPathKey = productCenterLink.replace(
        /https?:\/\/(etx-support-local\.autodesk\.com(:\d+)?)(\/.*)/,
        'autodesk.com$3'
      );
      break;
    case productCenterLink.includes('etx-support'):
      validPathKey = productCenterLink.replace(
        /https?:\/\/(app\.)?(etx-support(-(dev|stg|int))?\.autodesk\.com)(\/.*)/,
        'autodesk.com$5'
      );
      break;
    case productCenterLink.includes('www-pt.autodesk'):
      validPathKey = productCenterLink.replace(
        /https?:\/\/(www-pt\.autodesk\.com(\.cn)?|www-pt\.autodesk\.com(\.[a-z]{2})?)(\/.*)/,
        (match, p1, p2, p3, p4) => {
          if (p2 === '.cn') {
            return `autodesk.com.cn${p4}`;
          }
          return `autodesk.com${p4}`;
        }
      );
      break;
    case productCenterLink.includes('www.autodesk'):
      validPathKey = productCenterLink.replace(
        /https?:\/\/(www\.autodesk\.com(\.cn)?|www\.autodesk\.com(\.[a-z]{2})?)(\/.*)/,
        (match, p1, p2, p3, p4) => {
          if (p2 === '.cn') {
            return `autodesk.com.cn${p4}`;
          }

          return `autodesk.com${p4}`;
        }
      );
      break;
    default:
      validPathKey = productCenterLink;
  }

  return urlMapping[validPathKey] || productCenterLink;
};

// All test passed locally but once deployed chinese url are not mapped currectly. this is the workaround
const getProductLinkForChina = (productSlug) => {
  const chinaKey = `autodesk.com.cn/products/${productSlug}/overview`;
  return urlMapping[chinaKey];
};

const productPageLink = (language, productSlug) => {
  // CountryCode use to build product center link
  // LanguageCode to determine the special U.S China cases
  // e.g es-MX -> es-ES -> es, en-AU -> en, ko-KR -> kr
  const [languageCode, countryCode] = language.split('-');
  const parsedCountryCode = countryCode
    ? countryCode.toLowerCase()
    : languageCode;
  const productPath = `products/${productSlug}/overview`;
  let productCenterLink = `${window.location.origin}/${parsedCountryCode}/${productPath}`;

  // use the same origin if the language is en or zh
  if (['en', 'zh'].includes(languageCode) || !languageCode) {
    productCenterLink = `${window.location.origin}/${productPath}`;

    if (['zh'].includes(languageCode)) {
      return getProductLinkForChina(productSlug) || productCenterLink;
    }
  }

  return getValidProductCenterUrl(productCenterLink);
};

//  eslint-disable-next-line
export { productPageLink, getValidProductCenterUrl };
